export enum BusinessInsuredSalaryRate {
  EIGHTY_PERCENT = 'EIGHTY_PERCENT',
  ONE_HUNDRED_PERCENT = 'ONE_HUNDRED_PERCENT',
}

export const BUSINESS_INSURED_SALARY_RATE_VALUES = Object.values(
  BusinessInsuredSalaryRate
);

export const getBusinessInsuredSalaryRateLabel = (
  value: BusinessInsuredSalaryRate
) => {
  switch (value) {
    case BusinessInsuredSalaryRate.EIGHTY_PERCENT:
      return '80%';
    case BusinessInsuredSalaryRate.ONE_HUNDRED_PERCENT:
      return '100%';
  }
};
